<template>
  <div class="map-root select-none">
    <div ref="map-mapview" class="map"></div>
    <div class="global-loading">
      <table>
        <tr>
          <td>
            <span class="global-loading-text" v-html="loadingText"></span>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  // 可接收 URL 参数。
  // 仅当通过 url 跳转的时候可接收这些参数。
  // 也可通过 this.$route.query 来查询 url 参数。
  props: {
    MapKey: {
      required: true,
      type: String,
    },
  },
  data() {
    return {
      loadingText: "加载中...",
    };
  },
  methods: {
    goCenter: function () {
      // eslint-disable-next-line no-undef
      this.mapInstance.panTo(new BMap.Point(this.center[0], this.center[1]));
    },
    addDom: function () {
      if (!this.mapInstance) return;

      // eslint-disable-next-line no-undef
      var $div = $("<div></div>");
      $div.append(this.getSvgContent());
      $div.css({
        width: "30rem",
        height: "30rem",
        "margin-left": "-15rem",
        "margin-top": "-15rem",
        position: "absolute",
      });

      var interval = setInterval(() => {
        let layer = this.mapInstance.getLayerByName("DOM");
        if (layer && layer.addDom) {
          clearInterval(interval);
          layer.addDom(this.center[0], this.center[1], $div[0]);
        }
      }, 1000);
    },
    addBlinkPoi: function () {
      if (this.mapInstance) {
        // eslint-disable-next-line no-undef
        var target = new BMap.Point(this.center[0], this.center[1]);
        //this.mapInstance.panTo(center);
        this.mapInstance.panTo(target);
        var pictureUrl = this.BASE_URL + "theme/default/img/animation10.gif";
        // eslint-disable-next-line no-undef
        var myIcon = new BMap.Icon(pictureUrl, new BMap.Size(1000, 1000));
        // eslint-disable-next-line no-undef
        var marker = new BMap.Marker(target, { icon: myIcon }); // 创建标注
        this.mapInstance.addOverlay(marker);
      }
    },
    getSvgContent: function () {
      var html =
        "" +
        '<div class="svg_container">' +
        '  <div class="svg-box">' +
        '     <svg version="1.1"  x="0px" y="0px" viewBox="0 0 100 100"' +
        '         enable-background="new 0 0 100 100" xml:space="preserve">' +
        '       <circle fill="rgba(244,16,11,5)" cx="50" cy="50" r="5" />' +
        '       <circle fill="rgba(244,16,11,0.2)" cx="50" cy="50" r="20" />' +
        '       <circle fill="rgba(244,16,11,0.1)" cx="50" cy="50" r="35" />' +
        "     </svg>" +
        "  </div>" +
        '  <div class="circle delay1"></div>' +
        '  <div class="circle delay2"></div>' +
        '  <div class="circle delay3"></div>' +
        "</div>";
      return html;
    },
    //资源点查询方法，过滤地图点位
    search: function (text) {
      var map = this.mapInstance;
      var layers = map.getLayers();

      if (text) {
        // eslint-disable-next-line no-undef
        $(layers).each(function () {
          if (this.$className === "OverlayLayer") {
            this.filter(function (d) {
              var label = this.getLabel(d) || "";
              return label.indexOf(text) >= 0;
            });
          }
        });
      } else {
        // eslint-disable-next-line no-undef
        $(layers).each(function () {
          if (this.$className === "OverlayLayer") {
            this.clearFilter();
          }
        });
      }
    },
    // eslint-disable-next-line no-unused-vars
    onSearchResultPoiSelected: function (id) {
      console.log("onSearchResultPoiSelected:" + id);

      var overlay,
        layers = this.mapInstance.getLayers();

      for (let index = 0; index < layers.length; index++) {
        var ly = layers[index];
        if (ly.findOverlayById) {
          overlay = ly.findOverlayById(id);
          if (overlay && overlay.length > 0) {
            ly.onClick.apply(overlay[0], [{}]);
            break;
          }
        }
      }
    },
  },
  created() {
    console.debug("mapview created");
    // 组件创建时，设置本页样式
    // eslint-disable-next-line no-undef
    $(".zj-app").addClass("zj-fullscreen-mapview");
    this.$on("poiselected", this.onSearchResultPoiSelected);
  },
  mounted() {
    // 创建地图，并通过样式让地图填满窗口
    let that = this;
    let mapkey = this.MapKey;
    this.$nextTick(function () {
      // 不传入 syscode 和 key ，或者值为空时，
      // zjumap 插件自动从 URL 地址
      // http://HOST:PORT/Areas/Map/Content/UMap.html?syscode=xxx&key=yyy
      // 中读取 syscode 和 key 的值。
      // eslint-disable-next-line no-undef
      $(that.$refs["map-mapview"]).zjumap({
        syscode: "ZJMap",
        key: mapkey,
        loading: ".global-loading",
        loadingText: ".global-loading-text",
        //地图配置
        mapConfigs: {
          // mapStyle: "styles/darknight.json",
          //toggleTool: "tool/TreeToggleX",
          //tilesPath: "",
          //zoom:16,
          //mapVender: that.MapVender,
          onMapCreated: function (e) {
            that.mapInstance = e.map;
            that.center = e.map.config.center;
            //that.addDom();
          },
          onGettingLayerData: function (e) {
            // eslint-disable-next-line no-undef
            e.opts.ServiceData = $.extend({}, e.opts.ServiceData, {
              Longitude: that.center[0],
              Latitude: that.center[1],
            });
          },
          //地图开关面板切换事件，切换右侧列表框的tab项
          // onToogleSwitchClick: function (e) {
          //   that.broadcast(
          //     "componentPOISearchResult",
          //     "onMapToogleSwitchClick",
          //     e.type
          //   );
          // },
          // onLayerDetaiButtonClick: function (e) {
          //   console.log(e);
          //   var item = e.originEvent.currentTarget;
          //   // eslint-disable-next-line no-undef
          //   var id = $(item).data("id");
          //   // eslint-disable-next-line no-undef
          //   var category = $(item).data("category");
          //   var result = {
          //     obj: id,
          //     type: "search",
          //     category: category,
          //   };
          //   that.showRecordDetail(result);
          // },
        },
        //,gotMapConfigs: function (conf, opts) { } //当从统一配置中获取到地图配置，并合并完 mapConfigs 后，触发此事件。
      });
    });
  },
  beforeDestroy() {
    if (this.mapInstance) {
      this.mapInstance.destroy();
      this.mapInstance = null;
      console.debug("mapview beforeDestroy");
    }
  },
  destroyed() {
    console.debug("mapview destroyed");
    // 销毁组件时，还原样式
    // eslint-disable-next-line no-undef
    $(".zj-app").removeClass("zj-fullscreen-mapview");
  },
};
</script>